import styled from "styled-components";

type ColorProps = { color: string };
type BackgroundProps = { background: string };
type BorderProps = { borderColor: string };
type ActionButtonProps = { background: string; color: string; borderColor: string };

export const TableWrapper = styled.div<BorderProps>`
    width: calc(100% - 32px);
    border: 1px solid ${props => props.borderColor};
    border-radius: 8px;
    overflow-x: auto;
    margin: 0 16px 16px;
`;

export const OverviewTable = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

export const TableHead = styled.thead``;

export const TableBody = styled.tbody``;

export const TableHeaderRow = styled.tr<BackgroundProps & BorderProps>`
    background: ${props => props.background};
    border-bottom: 1px solid ${props => props.borderColor};
`;

export const TableHeaderCell = styled.th<ColorProps>`
    padding: 10px 14px;
    font-size: 11px;
    font-weight: 700;
    color: ${props => props.color};
    text-align: left;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    white-space: nowrap;

    &:last-child {
        text-align: center;
    }
`;

export const TableRow = styled.tr<BorderProps & BackgroundProps>`
    border-bottom: 1px solid ${props => props.borderColor};
    transition: background 0.12s;
    background: ${props => props.background};

    &:last-child {
        border-bottom: none;
    }
`;

export const ActionCellContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const TableCell = styled.td<ColorProps>`
    padding: 14px;
    font-size: 13px;
    color: ${props => props.color};
    vertical-align: middle;

    &:last-child {
        text-align: center;
    }
`;

export const ProductCellContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
`;

export const ProductTextBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const ProductIconWrapper = styled.div<BackgroundProps & ColorProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: ${props => props.background};
    color: ${props => props.color};
    flex-shrink: 0;
`;

export const ProductName = styled.span<ColorProps>`
    font-size: 13px;
    font-weight: 600;
    color: ${props => props.color};
`;

export const DescriptionText = styled.span<ColorProps>`
    font-size: 12px;
    color: ${props => props.color};
`;

export const StatusBadge = styled.div<BackgroundProps & ColorProps>`
    display: inline-flex;
    align-items: center;
    padding: 3px 10px;
    border-radius: 100px;
    background: ${props => props.background};
    font-size: 11px;
    font-weight: 600;
    color: ${props => props.color};
    white-space: nowrap;
`;

export const ValueText = styled.span<ColorProps>`
    font-size: 13px;
    font-weight: 600;
    color: ${props => props.color};
`;

export const ActionButton = styled.button<ActionButtonProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 14px;
    border-radius: 7px;
    border: 1px solid ${props => props.borderColor};
    background: ${props => props.background};
    color: ${props => props.color};
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: opacity 0.15s;
    white-space: nowrap;

    &:hover:not(:disabled) {
        opacity: 0.82;
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }
`;

export const ContentButton = styled.div`
    display: flex;
`;
